// extracted by mini-css-extract-plugin
export var dropdown = "_fs-0";
export var imagePlaceholder = "_fs-2";
export var imageWrapper = "_fs-3";
export var productImage = "_fs-1";
export var truncateContainer = "_fs-4";
export var truncateText = "_fs-5";